import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://bubblesbark.com';

export default function Seo({ title, description, path = '/' }) {
  const fullTitle = title
    ? `${title} | Bubbles & Bark — Premium Pet Spa, Orlando`
    : 'Bubbles & Bark — Premium Pet Grooming & Spa, Orlando FL';
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE}${path}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${SITE}${path}`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${SITE}/Bubbles-Bark-01.png`} />
    </Helmet>
  );
}
